import axios from 'axios';
import { apiClient } from '../api/client';
import { API_BASE_URL } from '../api/config';
import type { LoginResponse } from './authStore';

export interface LoginRequest {
  identifier: string;
  password: string;
}

export async function login(
  tenantSlug: string,
  request: LoginRequest,
): Promise<LoginResponse> {
  // Use a one-off axios call rather than the interceptor-equipped client so
  // a 401 from bad credentials doesn't accidentally trigger the refresh flow.
  const response = await axios.post<LoginResponse>(
    `${API_BASE_URL}/api/auth/login`,
    request,
    {
      withCredentials: true,
      headers: { 'X-Tenant-Slug': tenantSlug },
    },
  );
  return response.data;
}

export async function logout(tenantSlug: string | null): Promise<void> {
  await apiClient.post(
    '/api/auth/logout',
    {},
    tenantSlug ? { headers: { 'X-Tenant-Slug': tenantSlug } } : undefined,
  );
}
